import { yellow } from '@mui/material/colors'

export const getImportanceColor = (
  importanceTypeId,
  transparent,
  getBorderColor
) => {
  if (!importanceTypeId) return 'white'

  const color = getBorderColor
    ? { 1: '#949292', 2: yellow[700], 3: '#961818' }[importanceTypeId]
    : {
        1: '#FFFFFF',
        2: yellow[200],
        3: '#fe3333',
      }[importanceTypeId]

  return color + (transparent ? 'b5' : '')
}

export const pickTextColorBasedOnBgColorSimple = (
  bgColor,
  lightColor,
  darkColor
) => {
  var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor
  var r = parseInt(color.substring(0, 2), 16) // hexToR
  var g = parseInt(color.substring(2, 4), 16) // hexToG
  var b = parseInt(color.substring(4, 6), 16) // hexToB
  return r * 0.299 + g * 0.587 + b * 0.114 > 130 ? darkColor : lightColor
}
